module.exports = __webpack_public_path__ + "img/serverError.4768ff5f.svg";